import { useState } from "react";
import { FaBars, FaPhoneAlt, FaTimes } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import classes from "./HeaderTwo.module.css";
import ButtonComp from "../../ButtonComp";

export default function HeaderTwo() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={classes.header}>
      <div className={classes.container}>
        {/* Logo */}
        <div className={classes.logo}>
          <Link to="/">
            {" "}
            <img src="/techmatter_uk_color_logo.png" alt="TechMatter" />{" "}
          </Link>
        </div>

        {/* Hamburger Icon */}
        <div className={classes.hamburger} onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>

        {/* Navigation */}
        <nav className={`${classes.nav} ${menuOpen ? classes.showMenu : ""}`}>
          <NavLink to="/" onClick={closeMenu} className={classes.navItem}>
            Home
          </NavLink>
          <NavLink to="/about" onClick={closeMenu} className={classes.navItem}>
            About
          </NavLink>
          <NavLink to="/shop" onClick={closeMenu} className={classes.navItem}>
            Shop
          </NavLink>

          <NavLink
            to="/contact"
            onClick={closeMenu}
            className={classes.navItem}
          >
            Contact
          </NavLink>
        </nav>

        {/* Contact Info + Button */}
        <div className={classes.contact}>
          <div className={classes.phone}>
            <FaPhoneAlt className={classes.phoneIcon} />
            <Link to="tel:+442031293546">+44 20 3129 3546</Link>
          </div>
          <ButtonComp link="/contact" text="Get a Quote" />
        </div>
      </div>
    </header>
  );
}
